import settingsService from '@/services/http/content/SettingsService'

export const settings = () => {
  return {
    namespaced: true,
    state: {
      loading: false,
      settings: [],
      event: undefined
    },
    mutations: {
      SET_LOADING (state, loading) {
        state.loading = loading
      },
      SET_SETTINGS (state, events) {
        state.settings = events
      }
    },
    actions: {
      async fetchSettings ({ commit }) {
        commit('SET_LOADING', true)
        const settings = await settingsService.fetchSettings()
        commit('SET_SETTINGS', settings)
        commit('SET_LOADING', false)

      }
    }
  }
}
